import ACTIONS from '@/storeActions';

class BusinessLogicAssessments {
  constructor(store, apiRequest, i18n) {
    this.store = store;
    this.apiRequest = apiRequest;
    this.i18n = i18n;
  }

  loadAssessments() {
    const self = this;

    const result = new Promise((resolve, reject) => {
      self.apiRequest.get('/assessments').then((data) => {
        self.store.dispatch(ACTIONS.SET_ASSESSMENTS, data);
        this.deleteAssessments(data);
        resolve(data);
      }).catch((error) => {
        console.log('error', error);
        let errorMessage = null;
        switch (error.status) {
          default:
            errorMessage = 'Errors.unknown';
        }
        self.store.dispatch(ACTIONS.SET_SNACKBAR, { text: self.$i18n.t(errorMessage), color: 'error' });
        reject(error);
      });
    });

    return result;
  }

  deleteAssessments(assessments) {

    let deleteList = [];

    for (let a of assessments) {
      deleteList.push(a.id);
    }
  }

  // syncAllAssessments() {
  //   console.log('SYNC ALL ASSESSMENTS');
  //
  //   // if sync is allowed but observer is not observing
  //   if (this.store?.state?.runInfo?.runInformation?.syncFromAppToCockpitAllowed === false) {
  //     console.log('Skipped sync - not allowed currently');
  //     return;
  //   }
  //
  //   const self = this;
  //
  //   const createDone = (item) => {
  //     if (item) {
  //       self.store.dispatch(ACTIONS.SET_SINGLE_ASSESSMENT, Object.assign(item, { syncError: false }));
  //     }
  //   };
  //
  //   const updateDone = (item) => {
  //     if (item) {
  //       self.store.dispatch(ACTIONS.SET_SINGLE_ASSESSMENT, Object.assign(item, { syncError: false }));
  //     }
  //   };
  //
  //   const failedUpdates = this.store.state.assessments.filter( (ass) => ass.syncError === true && ass.id != null );
  //   const failedCreates = this.store.state.assessments.filter( (ass) => ass.syncError === true && ass.id == null );
  //
  //   failedCreates.reduce( (previousPromise, nextAssessment) => previousPromise.then((result) => {
  //     createDone(result);
  //
  //     console.log('SYNC create ASSESSMENT', nextAssessment);
  //     const toSend = JSON.parse(JSON.stringify(nextAssessment));
  //     delete toSend.temporaryId;
  //     delete toSend.syncError;
  //     delete toSend.id;
  //
  //     return this.apiRequest.post('/assessments', [nextAssessment]);
  //   }).catch( (error) => console.log('CREATE ERROR', error) ), Promise.resolve())
  //     .then((result) => createDone(result));
  //
  //   failedUpdates.reduce( (previousPromise, nextAssessment) => previousPromise.then((result) => {
  //     updateDone(result);
  //
  //     console.log('SYNC create ASSESSMENT', nextAssessment);
  //     return this.apiRequest.put('/assessments', [nextAssessment]);
  //   }).catch( (error) => console.log('CREATE ERROR', error) ), Promise.resolve())
  //     .then((result) => updateDone(result));
  //
  // }
}

export default BusinessLogicAssessments;
